import React, { useRef, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import ButtonSection from "../../component/buttonSection";
import FlatlistNews from "../../component/FlatListNews";
import { styles } from "./style";
export default function index({ navigation }) {
  return (
    <View style={styles.container}>
      <Header backgroundColorHome="#FFFFFF" Admin navigation={navigation} />
      <ScrollView>
        <View>
          <Background navigation={navigation} Title="NEWS" admin />
          <View style={styles.viewListDetail}>
            <FlatlistNews
              navigation={navigation}
              InfoGuestAdmin={"InfoGuestAdmin"}
              onPress={() => {
                navigation.navigate("ConpeInformation");
              }}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
